import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ApiConfig} from "../api-config";
import {Customer} from "../../models";

@Injectable({
  providedIn: 'root'
})
export class BuildThemeService {
  constructor(private http: HttpClient) {

  }

  setNewTheme(customer: Customer, theme: any): Observable<Customer> {
    const url = ApiConfig.getApiUrl(`/customers/${customer.id}.json`, customer.subdomain);
    const settingsPayload: { customer: Pick<Customer, 'settings'> } = {
      customer: {
        settings: Object.assign({...customer.settings}, { styling: theme })
      }
    };
    return this.http.patch<Customer>(url, settingsPayload, { withCredentials: true });
  }
}
